/** Typeset placeholder for the client mark — swap for the approved Kyowa Kirin logo file. */
export function KyowaKirinWordmark() {
  return <span className="flex items-baseline whitespace-nowrap text-ink" aria-label="Kyowa Kirin" data-id="element-53" data-mp="1wp5s5v8hjmq4">
      <span className="text-[17px] font-semibold tracking-[-0.02em]" data-id="element-54" data-mp="2aoyg5ismnoue">Kyowa Kirin</span>
    </span>;
}